import Vue from 'vue';
import { gsap } from 'gsap';

Vue.component('dropdown-component', {
    props: {
        dropdownData: {
            type: Array,
            default: () => [],
        },
    },
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            selectedDropdownValue: '',
            selectedDropdownItem: null,
            dropdownIsOpen: false,
        };
    },

    watch: {
        selectedDropdownItem() {
            this.selectedDropdownValue = this.selectedDropdownItem.title;
            this.$emit('dropdown-change', this.selectedDropdownItem);
        },
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        EventBus.$on('set-dropdown-value', (value) => this.selectDropdownItem(null, value));

        this.dropdownList = this.$el.querySelector('.dropdown__list-holder');
        this.dropdownArrow = this.$el.querySelector('.dropdown-select-arrow');

        setTimeout(() => {
            const element = document.querySelector('.filter__option');
            element.click();

            this.toggleDropdown();

            if (this.dropdownData.length > 0) {
                this.selectedDropdownValue = this.dropdownData[0].title;
            }
        }, 100);
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        toggleDropdown() {
            this.dropdownIsOpen = !this.dropdownIsOpen;

            const tl = gsap.timeline();

            tl
                .to(this.dropdownList, {
                    duration: 1,
                    height: this.dropdownIsOpen ? 'auto' : 0,
                    ease: 'power4.out',
                })
                .to(this.dropdownArrow, {
                    duration: 0.7,
                    rotate: this.dropdownIsOpen ? 180 : 0,
                    ease: 'power4.out',
                }, '<');
        },

        selectDropdownItem(e, selectedItem = null) {
            this.selectedDropdownItem = selectedItem;
        },
    },
});
